import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { UserQrComponent } from './user-qr.component';
import { MaterialModule } from 'src/app/core/material/material.module';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Permissions } from 'src/app/core/enums/permissions.enum';

@NgModule({
  declarations: [UserQrComponent],
  exports: [UserQrComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: UserQrComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'components.breadcrumb.qr',
          permission: [Permissions.COBRAR],
          status: true
        }
      }
    ]),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class UserQrModule {}
